import React, { useState } from 'react';
import { ProjectImage } from '../utils/types';
import { X, Calendar, User, Maximize2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ImageGalleryProps {
  images: ProjectImage[];
}
export function ImageGallery({
  images
}: ImageGalleryProps) {
  const [selectedImage, setSelectedImage] = useState<ProjectImage | null>(null);
  if (images.length === 0) {
    return <div className="text-center py-12 bg-gray-50 rounded-xl border border-dashed border-gray-300" data-id="element-112">
        <p className="text-gray-500" data-id="element-113">
          Aucune photo disponible pour ce chantier.
        </p>
      </div>;
  }
  return <>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-4" data-id="element-114">
        {images.map(image => <motion.div key={image.id} layoutId={`image-${image.id}`} className="group relative aspect-square rounded-lg overflow-hidden cursor-pointer bg-gray-100" onClick={() => setSelectedImage(image)} whileHover={{
        scale: 1.02
      }} transition={{
        duration: 0.2
      }} data-id="element-115">
            <img src={image.url} alt={image.description || 'Photo de chantier'} className="w-full h-full object-cover" data-id="element-116" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-117">
              <Maximize2 className="text-white drop-shadow-lg" size={24} data-id="element-118" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/60 to-transparent text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-119">
              <p className="font-medium truncate" data-id="element-120">{image.uploadedBy}</p>
              <p className="opacity-80" data-id="element-121">
                {new Date(image.uploadedAt).toLocaleDateString('fr-FR')}
              </p>
            </div>
          </motion.div>)}
      </div>

      <AnimatePresence data-id="element-122">
        {selectedImage && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 p-4 backdrop-blur-sm" onClick={() => setSelectedImage(null)} data-id="element-123">
            <div className="relative max-w-5xl w-full max-h-[90vh] flex flex-col" onClick={e => e.stopPropagation()} data-id="element-124">
              <button onClick={() => setSelectedImage(null)} className="absolute top-2 right-2 sm:top-4 sm:right-4 z-10 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-black/50 hover:bg-black/70 text-white rounded-full transition-colors backdrop-blur-sm" aria-label="Fermer" data-id="element-125">
                <X size={24} data-id="element-126" />
              </button>

              <motion.img layoutId={`image-${selectedImage.id}`} src={selectedImage.url} alt={selectedImage.description} className="w-full h-full object-contain rounded-lg max-h-[80vh] bg-black" data-id="element-127" />

              <div className="mt-4 bg-white rounded-lg p-3 sm:p-4 flex items-center justify-between" data-id="element-128">
                <div className="flex-1 min-w-0" data-id="element-129">
                  <p className="text-sm sm:text-base text-gray-900 font-medium truncate" data-id="element-130">
                    {selectedImage.description || 'Sans description'}
                  </p>
                  <div className="flex items-center gap-3 sm:gap-4 mt-1 text-xs sm:text-sm text-gray-500" data-id="element-131">
                    <div className="flex items-center gap-1" data-id="element-132">
                      <User size={14} data-id="element-133" />
                      <span className="truncate" data-id="element-134">
                        {selectedImage.uploadedBy}
                      </span>
                    </div>
                    <div className="flex items-center gap-1 flex-shrink-0" data-id="element-135">
                      <Calendar size={14} data-id="element-136" />
                      {new Date(selectedImage.uploadedAt).toLocaleDateString('fr-FR')}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}